import AuthService from './AuthService';
import axios from 'axios';

// async function performRestOp(path, body) {
// 	const idToken = await AuthService.getIdToken();
// 	const result = await axios.post(`${base}${path}`, body, { headers: { Authorization: `Bearer ${idToken}` } });
// 	return result.data;
// }

async function performRestOpNext(path, body) {
	console.log('performRestOpNext');
	const idToken = await AuthService.getIdToken();
	const result = await axios.post(`https://www.boardandkayak.com/api/secured/${path}`, body, { headers: { Authorization: `${idToken}` } });
	// const result = await axios.post(`http://localhost:3000/api/secured/${path}`, body, { headers: { Authorization: `${idToken}` } });
	return JSON.parse(result.data.body);
}

export default {
	performRestOpNext
};
